/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Assets, AssetsInterface } from "../Assets";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "oldAssets",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address payable",
        name: "relayerAddress",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
    ],
    name: "MetaTransactionExecuted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "accountTokens",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator_",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "addOperator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "burn",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "currentSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "deprecatedAssets",
    outputs: [
      {
        internalType: "contract IAssets",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddress",
        type: "address",
      },
      {
        internalType: "bytes",
        name: "functionSignature",
        type: "bytes",
      },
      {
        internalType: "bytes32",
        name: "sigR",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "sigS",
        type: "bytes32",
      },
      {
        internalType: "uint8",
        name: "sigV",
        type: "uint8",
      },
    ],
    name: "executeMetaTransaction",
    outputs: [
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    stateMutability: "payable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "forge",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address",
      },
    ],
    name: "getNonce",
    outputs: [
      {
        internalType: "uint256",
        name: "nonce",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "idRange",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "isApprovedOrOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "isOwner",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "nameForID",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "",
        type: "bytes",
      },
    ],
    name: "onERC1155Received",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
      {
        internalType: "bool",
        name: "isNFT",
        type: "bool",
      },
      {
        internalType: "uint256",
        name: "totalSupply",
        type: "uint256",
      },
      {
        internalType: "address[]",
        name: "operators",
        type: "address[]",
      },
    ],
    name: "register",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "contractAddress",
        type: "address",
      },
    ],
    name: "registerAssetContract",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator_",
        type: "address",
      },
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "removeOperator",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "name",
        type: "bytes32",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";

export class Assets__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(
    oldAssets: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Assets> {
    return super.deploy(oldAssets, overrides || {}) as Promise<Assets>;
  }
  getDeployTransaction(
    oldAssets: string,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(oldAssets, overrides || {});
  }
  attach(address: string): Assets {
    return super.attach(address) as Assets;
  }
  connect(signer: Signer): Assets__factory {
    return super.connect(signer) as Assets__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): AssetsInterface {
    return new utils.Interface(_abi) as AssetsInterface;
  }
  static connect(address: string, signerOrProvider: Signer | Provider): Assets {
    return new Contract(address, _abi, signerOrProvider) as Assets;
  }
}
